
export default {
  data() {
    return {
      termsConditionsInfo: '',
    }
  },
  async created() {
    // await this.getInfoList();
    await this.$store.dispatch('getShopInfo').then(res => {
      this.termsConditionsInfo = res.terms
    })
  },
  methods: {
    // getInfoList() {
    //   this.$axios.get('/others/clause').then(res => {
    //     if (res.code == 1) {
    //       this.termsConditionsInfo = res.result.content
    //     }
    //   })
    // },
  },
}
